
<template>
  <div class="limit-tip" :class="[type]" v-if="(type === 'danger' || type === 'warning') && text" @click="showGuide">
    {{text}}
  </div>
</template>

<script>
import {mapGetters} from 'vuex';
export default {
  data () {
    return {
      type: '',
      text: ''
    }
  },
  computed: {
    ...mapGetters([
      'TOOL',
      'UserEquity',
      'WorksId'
    ])
  },
  watch: {
    // type (val) {
    //   if (val === 'danger') {
    //     this.showWeakMsg();
    //   }
    // }
  },
  created () {
    this.init();
    eve.on("totalTime_danger", data => {
      this.type = data.type;
      this.text = this.createTipText();
      if (this.type === 'danger') {
        this.showWeakMsg();
      }
    });
    this.$bus.on('updateAllScenes', () => {
      this.init();
    });
  },
  methods: {
    init() {
      if (!this.TOOL) return;
      const timeAll = this.TOOL.getDuration();
      if (this.UserEquity.time && timeAll > this.UserEquity.time) {
        this.type = 'danger';
      } else if (this.UserEquity.time && timeAll >= this.UserEquity.time - 10000) {
        this.type = 'warning';
      } else {
        this.type = 'save';
      }
      this.text = this.createTipText();
    },
    createTipText() {
      if (!this.UserEquity.time) return '';
      const duration = this.UserEquity.time / 1000;
      const m = Math.floor(duration / 60);
      const s = duration % 60;
      // '最长1分30秒，已超过'
      return '上限为' + (m ? m + '分' : '') + (s ? s + '秒' : '') + (this.type === 'danger' ? '，已超过' : '，即将超过');
    },
    showGuide () {
      this.$memberGuide({
        show: true,
        context: this,
        funcRight: {
          type: "videoDuration",
          name: "视频时长",
        },
      });
    },
    showGuideIfexceeded(type = '') {
      const timeAll = this.TOOL.getDuration();
      if (this.UserEquity.time && timeAll >= this.UserEquity.time - 10000) {
        if (type === 'weak') {
          this.showWeakMsg();
        } else {
          this.showGuide();
        }
      }
    },
    showWeakMsg() {
      const draftIdsOfWeakMsgShown = localStorage.getItem('draftIdsOfWeakMsgShown');
      let list = [];
      try {
        list = JSON.parse(draftIdsOfWeakMsgShown) || [];
      } catch (e) {
        list = [];
      }
      const isExist = list.includes(this.WorksId);
      if (!isExist) {
        this.showGuide();
        localStorage.setItem('draftIdsOfWeakMsgShown', JSON.stringify([...list, this.WorksId]));
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.limit-tip {
  display: flex;
  justify-content: center;
  align-items: center;
  min-width: 149px;
  height: 26px;
  border-radius: 4px 4px 4px 4px;
  box-sizing: border-box;
  font-size: 12px;
  cursor: pointer;
  &.danger {
    color: #EA3D45;
    background: #FFE0E1;
  }
  &.warning {
    color: #5778FB;
    background: #E1E4F9;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/tool/timeline/limitTip.vue